import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
//import concordsignature from '../svg/concordsignature.png';

function Result(props) {

  const listItems = props.quizResult.map((gift) =>
    <li>{gift}</li>
  );

  return (
    <ReactCSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <div className="results">
        <p>Thank you for taking the Concord Church spiritual gifts assessment.
        Your results are listed below in order from highest to lowest. 
        For a more detailed definition of each gift, please click{'\u00A0'}
          <a target="_blank" rel="noopener noreferrer" href="https://youruniquedesign.github.io/short_descriptions_abbreviated.html">here </a>
        </p>

        <p>It is our prayer that you will be encouraged and empowered to grow in your 
          understanding and use of your gifts to grow people and to take your 
          Next Step with Christ!</p>

        <ol>{listItems}</ol>

        <p>Want to know how you can use your spiritual gifts? {'\u00A0'}
          <a target="_blank" rel="noopener noreferrer" href="https://c4265878.ssl.cf2.rackcdn.com/concorddallas.2208041657.Spiritual_Gifts_Ministry_Serve_Grid.pdf">Take a look at this form to help get you started.</a></p>

        <p>Are you ready to serve? Sign up to volunteer by {'\u00A0'}
          <a target="_blank" rel="noopener noreferrer" href="https://concorddallas.tpsdb.com/OnlineReg/7191">clicking here</a>.</p>

        <p>Someone from the respective ministry team will follow up with you. For questions, email {'\u00A0'}<a href="mailto:grow@concorddallas.org">grow@concorddallas.org</a></p>

        <p>Thank you for being willing to serve!</p>

        <p>Serving in his grace,</p>
        <p>Connections Ministry<br />
        6808 Pastor Bailey Drive, Dallas, TX 75237<br />
        T (214) 331-8522<br />
        www.concorddallas.org</p>
      </div>
    </ReactCSSTransitionGroup>
  );

}

Result.propTypes = {
  quizResult: PropTypes.array.isRequired,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/Result.js